import { render, staticRenderFns } from "./InstagramPostsModal.vue?vue&type=template&id=6bdf2474&scoped=true"
import script from "./InstagramPostsModal.vue?vue&type=script&lang=js"
export * from "./InstagramPostsModal.vue?vue&type=script&lang=js"
import style0 from "./InstagramPostsModal.vue?vue&type=style&index=0&id=6bdf2474&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bdf2474",
  null
  
)

export default component.exports